import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import * as S from './style';
import Header from '../Header';
import * as R from '../../constants/routes';
import { Hero, Portfolio, About, Contact, Resume, Services, Testimoials } from '../../pages';
const Navigation = () => {
  return (
    <S.Container className="container">
      <Router>
        <Header />
        <S.Section>
          <Routes>
            <Route path={R.HERO} caseSensitive={false} element={<Hero />} />
            <Route path={R.ABOUT} caseSensitive={false} element={<About />} />
            <Route path={R.PORTFOLIO} caseSensitive={false} element={<Portfolio />} />
            <Route path={R.SERVICES} caseSensitive={false} element={<Services />} />
            <Route path={R.TESTIMONIALS} caseSensitive={false} element={<Testimoials />} />
            <Route path={R.CONTACT} caseSensitive={false} element={<Contact />} />
            <Route path={R.RESUME} caseSensitive={false} element={<Resume />} />
          </Routes>
        </S.Section>
      </Router>
    </S.Container>
  );
};

export default Navigation;
